import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { login } from "../api/auth";
import { toast, ToastContainer, Zoom } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css"
import logo from '../img/logo/mobis_CI.png'
import axios from 'axios';
import store from '../redux/store';
import { setToken } from '../redux/slices/userSlice';

import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from '../authConfig';
import { Monitor, Shield } from 'lucide-react'

function Login() {

  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const message = sessionStorage.getItem("sessionTimeoutMessage");

    if (message) {
      sessionStorage.removeItem("sessionTimeoutMessage");
      toast.info(message);
    }
  }, []);

  useEffect(() => {
    if (!activeAccount) return;

    const request = {
      ...loginRequest,
      account: accounts[0]
    };

    // Acquire the API token BEFORE navigating to the protected page. Otherwise
    // the menu (and ImageViewer) mounts and fires its first request while MSAL
    // is still finishing redirect handling, so the request interceptor cannot
    // mint a token yet and the first call returns 401.
    (async () => {
      try {
        const response = await instance.acquireTokenSilent(request);
        store.dispatch(setToken({ token: response.accessToken }));
      } catch (error) {
        console.log("[ERROR] acquireTokenSilent, ", error);
      } finally {
        navigate("/mes/menu");
      }
    })();
  }, [activeAccount]);

  const handleRedirect = () => {
    store.dispatch(
      setToken({ token: "" })
    );
    instance.loginRedirect({
      ...loginRequest,
    }).catch(error =>
      console.log(error)
    );
  }

  // className="flex items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-blue-600 hover:bg-blue-700 rounded py-2 w-full transition duration-150 ease-in" onClick={handleRedirect}>

  return (
    <>
      <ToastContainer draggable={false} transition={Zoom} autoClose={3000} style={{ width: "100%", textAlign: "center", fontSize: "100%" }} hideProgressBar />
      <UnauthenticatedTemplate>
        <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center p-4">
          <div className="max-w-md w-full">
            {/* Logo and Title */}
            <div className="text-center mb-8">
              <div className="mx-auto w-16 h-16 bg-primary-600 rounded-2xl flex items-center justify-center mb-4">
                <Monitor className="h-8 w-8 text-white" />
              </div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">Production Monitor</h1>
              <p className="text-gray-600">Real-time production line monitoring system</p>
            </div>

            {/* Login Card */}
            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
              <div className="text-center mb-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-2">Sign in to continue</h2>
              </div>

              {/* Error Message */}
              {error && (
                <div className="mb-4 p-3 bg-danger-50 border border-danger-200 rounded-lg">
                  <p className="text-sm text-danger-700">{error}</p>
                </div>
              )}

              {/* Login Button */}
              <button
                onClick={handleRedirect}
                disabled={isLoading}
                className="w-full bg-primary-600 hover:bg-primary-700 disabled:bg-primary-400 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2 mb-4"
              >
                {isLoading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                    <span>Signing in...</span>
                  </>
                ) : (
                  <>
                    <Shield className="h-4 w-4" />
                    <span>Sign in with Microsoft</span>
                  </>
                )}
              </button>

              <div className="mb-6"></div>
            </div>

            {/* Footer */}
            <div className="text-center mt-8">
              <p className="text-xs text-gray-500">
                © 2025 MSV MES Team. Secure access for authorized personnel only.
              </p>
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </>
  )
}

export default Login;
